/**
 * Format a role's internal snake_case name for human display.
 *
 *   "admin"             → "Admin"
 *   "system_admin"      → "System Admin"
 *   "inventory_manager" → "Inventory Manager"
 *
 * The internal identifier (snake_case) stays the source of truth for
 * permission checks and API contracts; this is for UI labels only.
 */
export const formatRoleName = (name: string | null | undefined): string => {
  if (!name) return ""
  return name
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
